import { defineComponent as s, openBlock as a, createElementBlock as l, normalizeClass as t, withModifiers as o, createElementVNode as n, createCommentVNode as r } from "vue";
import { _ as u } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseFloatingLabel.css';const d = s({
  name: "BaseFloatingLabel",
  props: {
    labelState: {
      type: String,
      default: () => "inline-label"
    },
    isValid: {
      type: Boolean,
      default: () => null
    },
    labelText: {
      type: String,
      required: !0
    },
    disabled: {
      type: [String, Boolean],
      default: !1
    }
  },
  emits: ["click"]
}), p = ["for"], k = ["innerHTML"];
function m(e, i, c, f, b, y) {
  return a(), l("label", {
    for: e.$attrs.for,
    class: t(["uikit-absolute uikit-left-15px uikit-h-5 uikit-text-sm", [
      e.labelState,
      { "uikit-text-w-secondary": e.disabled },
      e.$attrs["label-classes"]
    ]]),
    onClick: i[0] || (i[0] = o(($) => e.$emit("click"), ["stop"]))
  }, [
    n("span", {
      class: t(["uikit-text uikit-font-medium uikit-text-w-black", { "!uikit-text-w-secondary": e.disabled }]),
      innerHTML: e.labelText
    }, null, 10, k),
    e.$attrs.required ? (a(), l("sup", {
      key: 0,
      class: t(["uikit-absolute -uikit-top-[0.3rem] uikit-text uikit-text-w-primary", { "uikit-text-w-secondary": e.disabled }])
    }, " *", 2)) : r("", !0)
  ], 10, p);
}
const g = /* @__PURE__ */ u(d, [["render", m], ["__scopeId", "data-v-bc398569"]]);
export {
  g as default
};
